// extracted by mini-css-extract-plugin
module.exports = {"textLine":"Text_textLine__uNSGA"};